import { Link } from "react-router-dom";

const portugueseAside: ILanguageAside = {
  aboutme: "Sobre mim",
  mytoolkit: "Minhas ferramentas",
  courses: "Cursos",
  projects: "Projetos",
  resume: "Currículo",
};

const portugueseHomepage: ILanguageHomepage = {
  whoami: "Quem sou eu",
  whoami_intro: () => (
    <span>
      Eu sou um engenheiro de software e professor de ciências da computação no{" "}
      <a target="_blank" href="https://www.youtube.com/@cs50xemportugues">
        {" "}
        CS50x em Português
      </a>
      , o curso de ciências da computação da Universidade Harvard em português.
    </span>
  ),
  whoami_tools: () => (
    <span>
      Minhas principais ferramentas de desenvolvimento são: Bash, C, JavaScript,
      Python, SQL e mais. Para ver uma lista de todas as minhas ferramentas de
      desenvolvimento, <Link to="/toolkit">clique aqui</Link>.
    </span>
  ),
  whoami_polyglot:
    "Curiosidade: Eu sei falar inglês, português, francês, espanhol, e outros 4 idiomas.",
  tutorials: "Últimos Tutoriais",
  latest_tutorial:
    "Meu último tutorial: API REST com NodeJS, Express, MongoDB, e TypeScript.",
  experience: "Experiência",
  job_title: "Engenheiro de Software",
  experience1:
    "Este é o curso de ciências da computação da Universidade Harvard em português. Construí a plataforma do curso, usando ferramentas como Flask, Python, C, ChatGPT, Bootstrap, HTML, CSS, e muito mais.",
  experience2:
    "Esta é uma plataforma de aprendizagem de idiomas construída com React, React Native, Flask, JavaScript, TypeScript, PostgreSQL, SQLAlchemy, Bootstrap, ChatGPT, e muito mais.",
  also_worked: "Eu também já trabalhei para",
  projects: "Projetos",
  view_projects: () => (
    <span>
      <strong>Para ver todos meus projetos</strong>,{" "}
      <Link to="projects">clique aqui</Link>.
    </span>
  ),
  education: "Educação",
  i_graduated:
    "Eu graduei nos seguintes cursos de ciências da computação do CS50, da Universidade de Harvard",
  cs50x: "Introdução às Ciências da Computação",
  cs50python: "Introdução à Programação com Python",
  cs50web: "Progração Web com Python e JavaScript",
  cs50ai: "Introdução à Inteligência Artificial com Python",
  ifes: "IFES 2019 - Bacharel em Sistemas de Informação",
};

const portugueseToolkit: ILanguageToolkit = {
  title: "Estas são as ferramentas que eu uso",
  description:
    "Eu tenho experiência com estas ferramentas de desenvolvimento de software.",
  databases: "Bancos de dados",
  aiDataScience: "IA e Ciência de Dados",
  os: "Sistemas Operacionais",
  noVideo: "Sem vídeo para esta tecnologia. 😔",
};

const portugueseCourses: ILanguageCourses = {
  title: "Estes são os cursos que eu ensino",
  topics: "Tópicos",
  languagePortuguese: "em Português",
  languageEnglish: "em Inglês",
  languageFrench: "em Francês",
  languageSpanish: "em Espanhol",
};

const portugueseProjects: ILanguageProjects = {
  allProjects: "Todos os Projetos",
  title: "Estes são alguns projetos que eu construí",
  intro:
    "Todos os projetos são full stack e combinam diferentes tecnologias para criar produtos e serviços valiosos.",
  realClient: "Projeto para Cliente Real",
  showall_filter: "Filtrar projetos: ",
  viewLiveProject: "Ver Projeto",
  viewGithubCode: "Ver Código Github",
  technologies: "Tecnologias",
  description: "Descrição",
  features: "Funcionalidades",
};

export const portugueseLanguage: ILanguage = {
  id: "portuguese",
  aside: portugueseAside,
  homepage: portugueseHomepage,
  toolkit: portugueseToolkit,
  courses: portugueseCourses,
  projects: portugueseProjects,
};
